import { traverse } from './traverse';
export function reduce(adf, callback, initial) {
  var result = initial;
  traverse(adf, {
    any: function any(node) {
      result = callback(result, node);
    }
  });
  return result;
}